import React from 'react';
import ICellProps, { ITranchRow } from './ICellProps';
import { formatNumberWithDecimals } from '@/creditflowresearch/ui/components/deals/helpers';
import { BodyCell } from '@creditflowresearch/uilib/Table/DataTable';

import alignStyles from '@creditflowresearch/uilib/styles/helpers/align.module.scss';

const getCell = ({ row: tranche }: ITranchRow) => (
  tranche.weightedAverageLife2
    ? formatNumberWithDecimals(tranche.weightedAverageLife2, 2)
    : '-'
);

const WalxCell = ({
  rowIndex,
  tranche,
}: ICellProps) => (
  <BodyCell
    name="WalxCell"
    className={ alignStyles.alignRight }
    rowIndex={ rowIndex }
    rowData={ tranche }
    cellCallback={ getCell }
  />
);

export default WalxCell;
